<template>
  <div class="lead-history">
    <div class="lead-history-container" ref="leadHistoryWrapper">
      <div class="lead-history-h" v-if="history && history.length > 0">
        <div class="lead-history-title">
          <span class="text">{{ $t('Leads.LeadHistoryPageTitle') }}</span>
        </div>
        <div class="lead-history-close" @click="emitToggleLeadHistory2">
          <icon-base width="16" height="16" view-box="0 0 7 7" icon-name="times"><icon-times /></icon-base>
        </div>
      </div>
      <div class="lead-history-b">
        <b-collapse
            class="card"
            animation="slide"
            v-for="(historyItem, index) of history"
            :key="index"
            :open="false"
            :aria-id="'contentIdForA11y5-' + index">
            <template #trigger="props">
                <div
                    class="card-header"
                    role="button"
                    :aria-controls="'contentIdForA11y5-' + index"
                >
                    <p class="card-header-title">
                        <span class="mx-auto">
                            {{ historyItem.FullName }}
                        </span>
                        <span class="mx-auto">
                            {{ formatDate(historyItem.CreateDate) }}
                        </span>
                    </p>
                    <a class="card-header-icon">
                        <b-icon
                            :icon="props.open ? 'menu-down' : 'menu-up'">
                        </b-icon>
                    </a>
                </div>
            </template>
            <div class="card-content">
                <div class="content">
                    <b-field label="ID">
                      <b-input :value="historyItem.ID" disabled></b-input>
                  </b-field>
                  <b-field :label="$t('Leads.Grid.Columns.CreateDate')">
                      <b-input :value="formatDate(historyItem.CreateDate)" disabled></b-input>
                  </b-field>
                  <b-field :label="$t('Leads.Grid.Columns.CampaignTitle')">
                      <b-input :value="historyItem.CampaignTitle" disabled></b-input>
                  </b-field>
                  <b-field :label="$t('Leads.Grid.Columns.ChannelMetadataTypeText')">
                      <b-input :value="historyItem.ChannelMetadataTypeText" disabled></b-input>
                  </b-field>
                  <b-field :label="$t('Leads.Grid.Columns.ProjectPerformanceTitle')">
                      <b-input :value="historyItem.ProjectPerformanceTitle" disabled></b-input>
                  </b-field>
                  <b-field :label="$t('Leads.Grid.Columns.AssetTitle')">
                      <b-input :value="historyItem.AssetTitle" disabled></b-input>
                  </b-field>
                  <b-field :label="$t('Leads.Grid.Columns.CallStatus')">
                      <b-input :value="historyItem.CallStatus" disabled></b-input>
                  </b-field>
                </div>
            </div>
        </b-collapse>
      </div>
    </div>
    <div class="lead-history-bg" @click="emitToggleLeadHistory2"></div>
  </div>
</template>

<script lang="ts">
import moment from "moment";
import { Component,  Prop,  Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ContactForm} from "@/models/leads/ContactForm";
import { DataSourceResult } from "@/models/DataSourceResult";
import { LeadsPageKind } from "@/models/LeadsPageKind";
import ApiService from "@/services/api/ApiService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconTimes from "../icons/IconTimes.vue";

const namespace = "leadsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconTimes,
  },
})
export default class LeadsGridContentHistory extends Vue {  
  @Prop({ required: true }) readonly pageKind!: LeadsPageKind;


  //#region Vuex getters and actions

  @Getter("selectedLeadClientId", { namespace }) selectedLeadClientId!: number;
  
  //#endregion Vuex getters and actions


  //#region Properties

  history : ContactForm[]= []; 
  isOpen : number = 0;

  //#endregion Properties
  

  //#region Lifecycle

  mounted(): void {
     let loader = this.$loading.show({
      container: this.$refs.leadHistoryWrapper
    });
     ApiService.getLeadHistory(this.selectedLeadClientId, this.pageKind)
     .then((data: DataSourceResult) => {
        this.history = data.Data as ContactForm[];
        loader.hide();
      });
  }

  //#endregion Lifecycle


  //#region Private methods

  formatDate(date: Date) {
    return moment(date).format("DD/MM/YYYY HH:mm");   
  }

  //#endregion Private methods


  emitToggleLeadHistory2(): void {
    this.$emit("toggle-lead-history2");
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

    .lead-history {
        position: fixed;
        z-index: 101;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;

        .lead-history-container {
            position: fixed;
            top: 0;
            right: 0;
            width: 477px;
            height: 100vh;
            z-index: 10;
            transition: all 0.5s;
            transform: translateX(0);
            background: #f6f7fb;

            @media (max-width: 991px) {
                // width: 100%;
                height: 100%;
            }

            @media (max-width: 575px) {
                width: 100%;
            }
        }

        .lead-history-h {
            position: fixed;
            top: 0;
            left: 0;
            height: 56px;
            width: 100%;
            color: #fff;
            display: flex;
            align-items: center;
            padding: 12px 15px 13px 10px;
            background: linear-gradient(90deg, $primary 0%, #1ca8d9 52.75%);

            .lead-history-close {
                padding: 5px;
                cursor: pointer;
                line-height: 0;
                margin: 0 0 0 auto;
                transition: all 0.2s;

                &:hover {
                    opacity: 0.8;
                }
            }

            .lead-history-title {
                display: flex;
                align-items: center;
                font-size: 21px;

                .icon-w {
                    margin-left: 10px;
                }
            }
        }

        .lead-history-b {
            position: fixed;
            top: 56px;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 22px 22px 40px;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            align-items: stretch;

            @media (max-width: 575px) {
                padding: 10px 15px 30px;
            }

            hr {
                border-bottom: 1px solid #e0e2eb;
                grid-column: 1 / 3;
                margin: 0 0 1rem;
            }

            .card {
                margin-bottom: .5rem;
            }       

            .textarea {
                height: 59px;
            }                    
        }

        .lead-history-bg {
            position: fixed;
            top: 0;
            right: 0;
            width: 100%;
            height: 100%;
            z-index: 9;
            transition: all 0.5s;
            background: rgba(0, 0, 0, 0.3);
        }
     
        &.fade-enter-active,
        &.fade-leave-active {
            z-index: 101;
            transition: all 0.5s;
        }

        &.fade-enter,
        &.fade-leave-to,
        &.fade-leave-active {
            opacity: 1;

            .lead-history-container {
                transform: translateX(100%);
            }

            .lead-history-bg {
                opacity: 0;
            }
        }

        &.active {
            z-index: 101;
        }
    }

    html[dir="rtl"] {
        .lead-history {
            .lead-history-b {
                .toolbar {
                    .toolbar-item {
                        .button {
                            .button-inner {
                                i {
                                    margin-inline-end: 0;
                                    margin-inline-start: .5rem;
                                }
                            }
                        }
                    }
                }
            }

            .lead-history-h {
                padding: 12px 15px 13px 10px;

                .lead-history-close {
                    margin: 0 auto 0 0;
                }
            }
        }
    }

    @media (resolution: 120dpi) {
        .lead-history .lead-history-container {
            height: 125%;
            max-height: 125%;
        }
        .lead-history .lead-history-bg {
            height: 125%;
        }
    }
</style>
